import { render, staticRenderFns } from "./exerland.vue?vue&type=template&id=34fcdd22&scoped=true&lang=html"
import script from "./exerland.vue?vue&type=script&lang=js"
export * from "./exerland.vue?vue&type=script&lang=js"
import style0 from "./exerland.vue?vue&type=style&index=0&id=34fcdd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fcdd22",
  null
  
)

export default component.exports